export const API_STATUS = {
  SUCCESS: 'success',
  ERROR: 'error',
};